import { useTranslation } from 'react-i18next';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useUserContext } from '@/contexts/UserContext';
import { Button } from '@mui/material';

import './Profile.css';

export function Profile() {
  const { user, logout } = useUserContext();
  const { t } = useTranslation();

  return (
    <div className="profile">
      <Person2OutlinedIcon className="person" fontSize="inherit" />
      <div className="name">
        {user?.name} ({user?.kid})
      </div>
      <Button className="button" variant="contained" onClick={logout}>
        <LogoutOutlinedIcon fontSize="medium" /> {t('home.profile.logout')}
      </Button>
    </div>
  );
}
